"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGraphqlFromJsonSchema = void 0;
const parseSchema_1 = require("./parseSchema");
const getGraphqlFromJsonSchema = function ({ rootName, schema, direction = 'output' }) {
    return parseSchema_1.parseSchema({ path: [rootName], schema, direction });
};
exports.getGraphqlFromJsonSchema = getGraphqlFromJsonSchema;
